import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { toaster } from "@/components/ui/toaster";

export function useInvoiceDeleteFeedback({
    isDeleteInvoiceSuccess,
    isDeleteInvoiceError,
    invoiceId,
    broadcast,
    navigate,
    t
}: {
    isDeleteInvoiceSuccess: boolean;
    isDeleteInvoiceError: boolean;
    invoiceId: string;
    broadcast: (msg: { type: string; invoiceId: string }) => void;
    navigate: ReturnType<typeof useNavigate>;
    t: (key: string) => string;
}) {
    useEffect(() => {
        if (isDeleteInvoiceSuccess) {
            broadcast({
                type: "INVOICE_DELETED",
                invoiceId
            });
            toaster.create({
                id: "invoiceDeleted",
                title: t("invoices:createInvoice.invoiceDeleted"),
                type: "success",
                closable: true
            });
            navigate("/");
        }

        if (isDeleteInvoiceError) {
            toaster.create({
                id: "invoiceDeleteFailed",
                title: t("invoices:createInvoice.invoiceDeleteFailed"),
                type: "error",
                closable: true
            });
        }
    }, [broadcast, isDeleteInvoiceSuccess, isDeleteInvoiceError, invoiceId, navigate, t]);
}
